module.exports = __webpack_public_path__ + "static/media/mastercard3x.87cb71b1.svg";